var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterThanBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40263 8.16119C9.41619 8.11317 9.42305 8.06252 9.42217 8.01046C9.42217 8.01046 9.42217 8.01045 9.42217 8.01045L8.92224 8.01892C8.91946 7.85472 8.84773 7.67821 8.70704 7.54181L2.24863 1.28026C1.96159 1.00197 1.51667 1.00197 1.22963 1.28026C0.942591 1.55855 0.942591 1.9899 1.22963 2.26819L5.6903 6.59288C6.50075 7.37863 6.50075 8.67899 5.6903 9.46474L1.21528 13.8033C0.92824 14.0816 0.92824 14.513 1.21528 14.7913C1.50232 15.0696 1.94723 15.0696 2.23427 14.7913L9.40263 8.16119ZM9.40263 8.16119C9.39084 8.28157 9.35987 8.39945 9.31079 8.51047C9.24629 8.65639 9.15215 8.7868 9.03509 8.89419L9.40263 8.16119Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanBlack);
export default __webpack_public_path__ + "static/media/greater-than-black.07dce7033cd6b67d72ce2eb836b2d231.svg";
export { ForwardRef as ReactComponent };